import { render, staticRenderFns } from "./FeedbackSendList.vue?vue&type=template&id=7b050035&scoped=true&"
import script from "./FeedbackSendList.vue?vue&type=script&lang=js&"
export * from "./FeedbackSendList.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackSendList.vue?vue&type=style&index=0&id=7b050035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b050035",
  null
  
)

export default component.exports